import { store } from "../../store";
import { windowContentScaleX, windowContentScaleY } from '../common/content_scale';
import { settingStore } from '../store/settingStore';
import { TOOLS } from "../toolbar/tools";
export default class Cursor {
    _menuRight = null;
    _menuMiddle = null;
    _switch = false;

    _middleTimeOut = 0;

    static instance;
    static getInstance() {
        if (this.instance == null) {
            this.instance = new Cursor();
        }

        return this.instance;
    }

    constructor() { }

    setMenuMiddle(menuMiddle) {
        this._menuMiddle = menuMiddle;
    }

    setMenuRight(menuRight) {
        this._menuRight = menuRight;
    }

    setSwitch(bool) {
        this._switch = bool;
    }

    cursorClick(event) {
        let button = event.button;
        // event.stopPropagation();

        if (store.nowTool == TOOLS.STAMP.TOOL) return;

        if (button == 1) { // 滑鼠中鍵
            if (this._switch) { // 功能互換
                this.customShortcutShow(event);
            } else {
                this.nextQuickShortcut();
            }
        }
        else if (button == 2) { //滑鼠右鍵
            if (this._switch) { // 功能互換
                this.nextQuickShortcut();
            } else {
                this.customShortcutShow(event);
            }
        }
    }

    nextQuickShortcut() {
        this._menuMiddle.nextShortcut();
        this._menuMiddle.show = true;

        this._middleTimeOut = setTimeout(() => {
            this._menuMiddle.show = false;
            this._middleTimeOut = 0;
        }, 1000);
    }

    customShortcutShow(event) {
        this._menuRight.x = (event.clientX - store.contentSize.x) / windowContentScaleX.value;
        this._menuRight.y = (event.clientY - store.contentSize.y) / windowContentScaleY.value;
        this._menuRight.show = true;
    }
}